import React, { Fragment } from 'react';
import Header4 from '../../components/header4/Header4';
import Hero44 from '../../components/hero4/hero44';
import PartnerSection from '../../components/Cyber-Security-Components/PartnerSection/PartnerSection';
import ServiceSection from '../../components/Cloud-devops-components/ServiceSection/ServiceSection';
import About from '../../components/Cyber-Security-Components/about/about';
import WorkProcess from '../../components/WorkProcess/WorkProcess';
import WorkFlow from '../../components/Cyber-Security-Components/WorkFlow/WorkFlow';
import AwardSection from '../AboutUsPage/AwardSection';
import StickyScrollRevealDemo from '../AboutUsPage/WhyChoose';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/Cyber-Security-Components/Footer/Footer';



const HomePage = () => {

    return (
        <Fragment>
            <div className='cybersecurity body_wrap sco_agency'>
                <main className=" page_content">
                    <div className='colour8'></div> 
                    <Header4 />
                    <Hero44 />
                    <PartnerSection />
                    <ServiceSection />
                    <div className='black-blue'>
                     <WorkProcess />
                     <AwardSection/>
                     <StickyScrollRevealDemo/>  
                    <About />
                    </div>
                    <WorkFlow />
                   
                </main>
                <Footer/>
                <Scrollbar/>
            </div>
        </Fragment>
    )
};
export default HomePage;